module.exports = "#qgen-kyc {\n    height: 600px;\n    max-height: 100vh;\n    max-width: 720px;\n    width: 720px;\n    margin: 4rem auto 0;\n}\n"